import React from 'react'
export default function BaseInput ({
  labelWrapperClass,
  labelClass,
  label,
  ...props
}) {
  return (
    <label className={`input-field ${labelWrapperClass}`}>
      <input {...props} />
      <span className={`label-text ${labelClass}`}>{label}</span>
    </label>
  )
}
